module.exports = __webpack_public_path__ + "media/images/arrows/twisted/green-right-3b4f216100479026880a1ceb58d9aad0.svg";